<!-- =========================================================================================
  File Name: UploadFileList.vue
  Description: Upload - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="capacity-list-view">
		<slot></slot>
		<div class="vx-card p-6" :noShadow="customConfig.showPopup">
			<div class="flex flex-wrap items-center justify-end" v-if="customConfig.tableOptions">
				<!-- ITEMS PER PAGE -->
				<div class="flex-grow mt-2" v-if="customConfig.showItemsPerPage">
					<vs-dropdown vs-trigger-click class="cursor-pointer">
						<div
							class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
						>
							<span class="mr-2"
								>{{
									paginationPageSize === 0
										? 0
										: currentPage * paginationPageSize - (paginationPageSize - 1)
								}}
								-
								{{
									usersData.length - currentPage * paginationPageSize > 0
										? currentPage * paginationPageSize
										: usersData.length
								}}
								{{ $t("Of") }} {{ pagination.total_records }}</span
							>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<vs-dropdown-menu>
							<vs-dropdown-item @click="paginationSetPageSize(20)">
								<span>20</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(50)">
								<span>50</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(100)">
								<span>100</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(200)">
								<span>200</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
				<template>
					<!-- ITEMS PER PAGE -->
					<div class="vx-row mt-2">
						<vs-dropdown vs-trigger-click class="cursor-pointer">
							<div
								class="p-3 mt-1 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
							>
								<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
								<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
							</div>
							<vs-dropdown-menu>
								<vs-dropdown-item @click="setSearchField('Id')">
									<span>Id</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('ResourceModule.Table.Status')">
									<span>{{ $t("ResourceModule.Table.Status") }}</span>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>
				</template>
				<!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
				<vx-tooltip
					class="cursor-pointer md:w-1/3 w-full mt-2 ml-3"
					color="primary"
					position="bottom"
					delay=".1s"
					:title="$t('Search')"
					:text="$t('SearchSeparatedByCommas') + '.'"
				>
					<tags-input
						element-id="tags"
						v-model="searchQuery"
						add-tags-on-comma
						add-tags-on-blur
						:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
						:typeahead="true"
						@keyup.enter="search"
					></tags-input>
				</vx-tooltip>
				<div class="flex justify-between items-center mt-2">
					<vs-button
						class="ml-2"
						color="primary"
						icon-pack="feather"
						icon="icon-search"
						:title="$t('VisitPoints.Search')"
						@click.prevent="search"
					></vs-button>
					<vs-button
						class="ml-2 mr-2"
						color="primary"
						icon-pack="feather"
						icon="icon-refresh-cw"
						:title="$t('Refresh')"
						@click.prevent="refresh()"
					></vs-button>
					<vs-button
						class="mr-2"
						color="primary"
						icon-pack="feather"
						icon="icon-upload"
						:title="$t('Upload') + ' ' + $t('UploadFiles.File')"
						@click.prevent="addNewData"
					></vs-button>
				</div>
			</div>
			<!-- AgGrid Table -->
			<ag-grid-vue
				ref="agGridTable"
				colResizeDefault="shift"
				class="ag-theme-material w-100 my-4 ag-grid-table"
				:class="[{'ag-customizer-container': !isWidthPortatil}]"
				:style="!customConfig.tableOptions ? 'padding-top: 100px' : ''"
				:components="components"
				:gridOptions="gridOptions"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="usersData"
				:rowSelection="customConfig.rowSelection"
				:animateRows="true"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true"
				:enableRtl="$vs.rtl"
				:overlayNoRowsTemplate="overlayNoRowsTemplate"
				:overlayLoadingTemplate="overlayLoadingTemplate"
				:enableCellTextSelection="true"
			>
			</ag-grid-vue>
			<vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
		</div>
	</div>
</template>

<script>
import {uploadFileListMixin} from "./model/UploadFileListMixin";

export default {
	mixins: [uploadFileListMixin],
};
</script>
